import { useBrandSettings } from "@hooks/useBrandSettings";
import { IFeedbackFields, IFeedbackOutput } from "./data-interfaces";
import { useFetch } from "@hooks/useFetch";
import { getCaptchaToken } from "@components/organisms/feedback-form/ratings";
import FeedbackState from "@state/feedbackState";

export const useSendFeedback = () => {
  const {brand, apiUrl} = useBrandSettings();
  const URL = `${apiUrl}/public-feedback`;
  const { feedback } = FeedbackState.value;
  
  const options = {
    method: 'POST',
  };

  const captchaToken = getCaptchaToken();

  const data: IFeedbackFields = {
    app: brand,
    domain: window.location.hostname,
    rank: feedback.value.rank,
    url: window.location.href,
    description: feedback.value.feedbackText.value,
  };

  if (captchaToken) {
    data['hcaptcha_token'] = captchaToken;
  }

  if (feedback.value.email.value.length > 0) {
    data['email_address'] = feedback.value.email.value;
  }

  const handlers = useFetch<IFeedbackFields, IFeedbackOutput>(URL, options);

  return {
    ...handlers,
    handleFetch: () => {
      handlers.handleFetch(data);
    }
  }
}